var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5712 1.29968L7.29974 6.57111C7.26126 6.61211 7.21479 6.64479 7.16319 6.66712C7.11159 6.68946 7.05596 6.70098 6.99974 6.70098C6.94351 6.70098 6.88788 6.68946 6.83628 6.66712C6.78469 6.64479 6.73821 6.61211 6.69974 6.57111L1.42831 1.29968",
    stroke: "#434344",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/select-icon.a8eb614f9bbef6e6549a2a5779149293.svg";